export const version = "web/5.6.1";
//# sourceMappingURL=_version.js.map